import { IDeviceSignalGroup } from "@types"
import { protectedApi } from "store/Api"

const deviceSignalGroupsApi = protectedApi.injectEndpoints({

    endpoints: (builder) => ({
        fetchDeviceSignalGroups: builder.query<IDeviceSignalGroup[], void>({
            query: () => {
                return {
                    method: "GET",
                    url: `devices/signal_groups`,
                }
            },
        }),
    }),
})

export const { useFetchDeviceSignalGroupsQuery } = deviceSignalGroupsApi
